import { Store } from './types';

const STORE: Store = {
    app: {
        user: null,
        productCategories: null,
        notifications: [],
        categoryImages: null,
        tables: null,
        storeConfiguration: null,
        availableLanguages: null,
        products: null,
        users: null,
        loading: false,
        closures: null
    }
};

export default STORE;
